import { ErrorTemplate } from "../../components/templates/Error"

export function Component() {
  return <ErrorTemplate />
}
